<template>
  <v-card >
    <v-toolbar dense flat dark color="primary" class="mb-20">
      <v-toolbar-title class="body-2">{{ formTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
      <v-btn x-small icon @click="$emit('close')">
        <v-icon>fa fa-close</v-icon>
      </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <v-container>
        <v-row >
          <v-col cols="12" class="py-1">
            <v-tabs v-model="tab" dense class="mb-5"  >
              <v-tabs-slider></v-tabs-slider>
              <v-tab >Datos {{config.title}}</v-tab>
              <v-tab v-if="config.tUsr==1">Configuración</v-tab>
            </v-tabs>
                <v-tabs-items v-model="tab" touchless>
                  <v-tab-item >
                    <v-row >
                      <v-col cols=12 md=4>
                        <v-text-field
                          class="body-2"
                          v-model="frm.usr"
                          dense
                          hide-details 
                          :label="usuario"
                          placeholder=""
                          color="primary"
                          autocomplete=off
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols=12 md=8>
                        <v-text-field
                          class="body-2"
                          v-model="frm.pass"
                          dense
                          hide-details 
                          label="Contraseña"
                          placeholder=""
                          color="primary"
                          type="password"
                          autocomplete="off"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols=12 md=6>
                        <v-text-field 
                          class="body-2"
                          v-model="frm.nombre"
                          dense
                          hide-details 
                          label="Nombre" 
                          color="primary" 
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols=12 md=6>
                        <v-text-field 
                          v-if="config.tUsr==1"
                          class="body-2"
                          v-model="frm.nomFantasia"
                          dense
                          hide-details 
                          label="Nombre Fantasía" 
                          color="primary" 
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col v-if="config.tUsr==1"  cols=12 md=3>
                        <v-text-field 
                          class="body-2"
                          v-model="frm.cuit"
                          
                          dense
                          hide-details 
                          label="CUIT" 
                          color="primary" 
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols=12 md=4>
                        <v-text-field 
                          class="body-2"
                          v-model="frm.direccion"
                          dense
                          hide-details 
                          label="Dirección" 
                          color="primary" 
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols=12 md=4 >
                        <v-text-field 
                          class="body-2"
                          v-model="frm.provincia"
                          dense
                          hide-details 
                          label="Provincia" 
                          color="primary" 
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols=12 md=4 >
                        <v-text-field 
                          class="body-2"
                          v-model="frm.localidad"
                          dense
                          hide-details 
                          label="Localidad" 
                          color="primary" 
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols=12 md=4>
                        <v-text-field 
                          class="body-2"
                          v-model="frm.telefono"
                          dense
                          hide-details 
                          label="Teléfono" 
                          color="primary" 
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols=12 md=4>
                        <v-text-field 
                          class="body-2"
                          v-model="frm.celular"
                          dense
                          hide-details 
                          label="Celular" 
                          color="primary" 
                        >
                        </v-text-field>
                      </v-col>
                     <v-col cols=12 >
                        <v-text-field 
                          class="body-2"
                          v-model="frm.email"
                          dense
                          hide-details 
                          label="Email" 
                          color="primary" 
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols=12 md=4>
                        <v-select
                          v-show="config.tUsr==1"
                          :items="viajantes"
                          hide-details
                          dense 
                          label="Viajante" 
                          color="primary"
                          v-model="frm.viajanteID"
                         :menu-props="{auto: true, overflowY: true ,maxHeight:150}"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols=12 md=5>
                        <v-checkbox v-model="frm.estado" hide-details class="caption py-0 my-0">
                          <template v-slot:label>
                            <span class="caption">Habilitado</span>
                          </template>  
                        </v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row class="py-0">
                      <v-col cols=12 md=5>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <UsuarioMarcas :items="frm.descuentos"></UsuarioMarcas>
                  </v-tab-item>
<!--
                  <v-tab-item>

                    <v-row> 
                      <v-col cols="12" sm="6">
                        <v-container fluid class=" mx-0 my-0 py-0 " >
                        <template>
                          <v-card class="" height="400">
                            <v-card-title class="body-2 " >
                              <v-text-field 
                                dense 
                                outlined
                                hide-details 
                                placeholder="Buscar marcas..."
                                append-outer-icon="fa fa-search"
                                class="caption"
                                autocomplet=off

                                v-bind:value="marca"
                                v-on:input="debounceSearch($event)"

                              >
                              </v-text-field>
                            </v-card-title>
                            <v-card-text class="my-0 py-0" style="height:calc(100% - 120px);" >
                              MARCAS DISPONIBLES
                              <v-list dense class="pa-0 my-0" style="overflow-y:auto;height:calc(100%);">
                                <v-divider />
                                <template v-for="(item, i) in Marcas">
                                <v-list-item dense class="pa-0 my-0"  :key="i" >
                                  <v-list-item-content class="d-flex caption text-truncate mr-1" :title="item.marca">
                                    {{item.marca}}
                                  </v-list-item-content>
                                  <v-list-item-action class="ma-0 pa-0" >
                                    <v-btn icon @click="selectItem(item,item.id)">
                                      <v-icon small color="primary lighten-1">fa fa-check</v-icon>
                                    </v-btn>
                                  </v-list-item-action>
                                  
                                </v-list-item>
                                <v-divider :key="`divider${i}`"/>
                                </template>
                              </v-list>
                            </v-card-text>
                          </v-card>
                        </template>
                        </v-container>
                      </v-col>
                      <v-col  cols="12" sm="6">
                        <v-container fluid class="mx-0 my-0 py-0 " >
                        <template>
                          <v-card class="" height="400">
                            <v-card-title class="body-2">MARCAS SELECCIONADAS</v-card-title>
                            <v-card-text class="my-0 py-0" style="height:calc(100% - 80px);" >
                              <v-divider />
                              <v-list dense class="pa-0 my-0"   style="overflow-y:auto;height:calc(100%);">
                                <template v-for="(item, i) in MarcasSelected">
                                <v-list-item dense class="pa-0 my-0"  :key="i" >
                                  <v-list-item-content class="caption text-truncate mr-1" :title="item.marca">{{item.marca}}</v-list-item-content>
                                  <v-list-item-action class="ma-0 pa-0" >
                                    <v-btn icon @click="selectItem(item,0)">
                                      <v-icon small color="error">fa fa-close</v-icon>
                                    </v-btn>
                                  </v-list-item-action>
                                  
                                </v-list-item>
                                <v-divider :key="`divider${i}`"/>
                                </template>
                              </v-list>
                            </v-card-text>
                          </v-card>
                        </template>
                        </v-container>
                      </v-col>
                    </v-row> 
  
                  </v-tab-item>
                  -->
                </v-tabs-items>
          </v-col>
        </v-row>
<!--  -->
    <v-dialog v-if="dialogOK.open" v-model="dialogOK.open" persistent max-width="400">
      <v-card>
        <v-card-title class="">{{dialogOK.title}}</v-card-title>
        <v-card-text v-if="dialogOK.message.length" class="title">{{dialogOK.message}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="close()">CERRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> 
<!--  -->
      </v-container>
    </v-card-text>
    <v-card-actions >
      <v-spacer></v-spacer>
      <v-btn color="primary darken-1" text @click.stop="$emit('close')">Cancelar</v-btn>
      <v-btn color="primary darken-1" text @click.stop.prevent="submit()" :loading="flgSave" >
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>



<script>

import {mapGetters, mapMutations} from 'vuex'

import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, email,numeric } from 'vuelidate/lib/validators'

import {format} from 'date-fns'

export default {

    name: 'Usuario',

    components: {
      UsuarioMarcas : () => import ('@/componentsByM/Usuarios/Usuario_Marcas'),
    },

    props:['editedIndex','editedItem','config'],

    mixins: [validationMixin],

    validations: {

      frm: {
        nombre:{required,maxLength: maxLength(50),minLength:minLength(3)},  
        apellido:{required,maxLength: maxLength(50),minLength:minLength(3)},
        email: {required, email,maxLength: maxLength(80)},
        //celular:{required,maxLength: maxLength(25),minLength:minLength(6)},
        celular:{maxLength: maxLength(25)},
        tipoUsr:{required},
        //referencia:{required},

        razonSoc:{required,maxLength: maxLength(50),minLength:minLength(3)},
        tel:{required,maxLength: maxLength(18),minLength:minLength(6)},
        dir:{required,maxLength:maxLength(50),minLength:minLength(3)},
        localidad:{required,maxLength: maxLength(50),minLength:minLength(3)},
        provincia:{required},
        cp:{required,maxLength: maxLength(10),minLength:minLength(4)},
        tEmpresa:{required},
      } 
 

/*
      name: { required,// maxLength: maxLength(10) 
      },
      email: { required, email },
      select: { required },
      checkbox: {
        checked (val) {
          return val
        },
      },*/
    },

    data () {
      return {

        dialogOK:{
          open:false,
          title:"",
          message:""
        },


        flgSave:false,
        flgLocalidad:false,

        seccion:"",
        tab:0,

        errors:false,

        frm:{
          id:0,
          usr:"",
          pass:null,
          pass2:null,
          nombre:"",
          nomFantasia:"",
          cuit:"",
          tipo:1,
          email:"",
          telefono:"",
          celular:"",
          direccion:"",
          localidad:"",
          provincia:"",
          estado:1,

          descuentos:[],

          viajanteID:0

        },

        viajantes:[],

        //usuario_marcas:[]

        
        
      }
    },
    async created() {
      await this.initialize()
    },
    async mounted() {
      
    },
    destroyed: function (){
      //window.removeEventListener('beforeunload', this.closeWindow)
    },
    beforeDestroy: function () {
      //console.log("beforeDestroy")
      //this.closeWindow()
    },
    methods: {
      ...mapMutations(['setLogout']),

      selectItem(item,marcaID) {
        let editedIndex,editedItem
        
        editedIndex = this.marcas.indexOf(item)
        editedItem = Object.assign({}, item)
        editedItem.marcaID = marcaID

        if (!!marcaID){
          if(editedItem.action=='D') editedItem.action='U' 
        }
        else{
          if(editedItem.action=='U') editedItem.action='D'
        }

        Object.assign(this.marcas[editedIndex], editedItem)
      },


      
      async initialize(){
        try {
          this.frm.tipo=this.config.tUsr

          if (this.editedIndex>=0){
            let params
            //let response
            let opt={
              method: 'GET', 
              mode: 'cors'
            }

            console.log("RECUPERAR DATOS")
            
            /* INI usuarios */
           // params=`/?_filters=${JSON.stringify({id:this.editedItem.id})}&_orders=${JSON.stringify([{field:'usr',dir:'asc'}])}`
            let response = await fetch(`${this.ROOT_API}cms/usuarios/${this.editedItem.id}`, opt)
            if (response.ok){
              console.log("OK usuario")
              let data = await  response.json()

              console.log("data--->",data)

              let {id,usr,pass,tipo,nombre,nomFantasia,cuit,email,telefono,celular,direccion,localidad,provincia,estado,descuentos=[]} = data[0]

              this.frm={
                id,
                usr,
                pass,
                pass2:pass,
                tipo,
                nombre,
                nomFantasia,
                cuit,
                
                email,
                telefono,
                celular,
                direccion,
                localidad,
                provincia,
                estado,
                descuentos
              }
            }
            else {
              throw('ERROR: No se puedo recuperar datos del cliente')
              //console.log('ERROR: No se puedo recuperar datos del cliente')
            }

          }  
        }
        catch (err){
          //this.setNotif({status:true, text:err,color:"error"})
          alert(err)
        }
      },

      async submit () {
        //console.log("GRABAR!!!")
        this.flgSave=true
        try {
          let response
 
          if (this.frm.id==0)
          {
            let opt={
              method: 'POST', 
              mode: 'cors',
              headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
              },  
              body: JSON.stringify(this.frm)
            }
            response = await fetch(`${this.ROOT_API}cms/usuarios/`, opt)

            this.dialogOK={
              open:true,
              title:`${this.config.title} creado correctamente!`,
              message:''
            } 
          }
          else{

            let opt={
              method: 'PUT', 
              mode: 'cors',
              headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
              },  
              body: JSON.stringify(this.frm)
            }
            //console.log(opt)
            response = await fetch(`${this.ROOT_API}cms/usuarios/${this.frm.id}`, opt)
            this.close()
          }

        } 
        catch(err) { 
          //this.setNotif({status:true, text:"ERROR: No se pudo el crear/modificar el cliente.",color:"error"})
          alert(err)
        }       

        this.flgSave=false
      }, 

      close () {
        this.$emit("reload")
        this.$emit("close") 
      }
    },
    watch: {
      /*
      'categorie' : function (val) {

        console.log("val --> ", val)
        if (val && val!=undefined){
          console.log("buscamos subCategorias")
          this.loadSubCategories()
        } else {
          console.log("vaciamos subCategorias") 
          this.subCategories=[]
          this.subCategorie={}
        }
        
      }
      */
    },
    computed: {

      ...mapGetters(['SESSION','ROOT_API']),

      usuario: function (){
        return this.tUsr==1 ? 'Nro Cta.' : 'ID'
      },

      formTitle: function () {
        return this.editedIndex === -1 ? `Nuevo ${this.config.title}` : `Editar ${this.config.title}`
      },



      fechaAlta: function () {
        return //format(new Date(this.editedItem.fecha_insert), 'dd-MM-yyyy HH:mm:ss.00')
      },
      

      // INI VALIDACIONES
/*
      txtKeyErrors () {
        let errors=[]
        if(!this.txtKey.length) return errors
        !(!this.frm.keys.find(key => key == this.txtKey)) && errors.push("Palabra clave ya cargada")
        return errors
      },


      emailErrors () {
        const errors = []
        if (!this.$v.frm.email.$dirty) return errors

        !this.$v.frm.email.required && errors.push('Este campo no puede ser vacío')
        !this.$v.frm.email.email && errors.push('Debe ser un email válido')
        !this.$v.frm.email.maxLength && errors.push('Debe ser un email válido')

        return errors
      },

      nombreErrors () {
        const errors = []
        if (!this.$v.frm.nombre.$dirty) return errors
        !this.$v.frm.nombre.maxLength && errors.push('Este campo debe tener como máximo 50 caracteres')
        !this.$v.frm.nombre.minLength && errors.push('Este campo debe tener como mínimo 3 caracteres')
        !this.$v.frm.nombre.required && errors.push('Este campo no puede ser vacío')
        return errors
      },

      apellidoErrors () {
        const errors = []
        if (!this.$v.frm.apellido.$dirty) return errors
        !this.$v.frm.apellido.maxLength && errors.push('Este campo debe tener como máximo 50 caracteres')
        !this.$v.frm.apellido.minLength && errors.push('Este campo debe tener como mínimo 3 caracteres')
        !this.$v.frm.apellido.required && errors.push('Este campo no puede ser vacío')
        return errors
      },

      celularErrors (){
        const errors = []
        if (!this.$v.frm.celular.$dirty) return errors
        //!this.$v.frm.celular.required && errors.push('Este campo no puede ser vacío')
        !this.$v.frm.celular.maxLength && errors.push('Este campo debe tener formato válido')
        //!this.$v.frm.celular.minLength && errors.push('Este campo debe tener formato válido')
        return errors

      },

      tipoUsrErrors () {
        const errors = []
        if (!this.$v.frm.tipoUsr.$dirty) return errors
        !this.$v.frm.tipoUsr.required && errors.push('Debe seleccionar una opción')
        return errors
      },

      referenciaErrors () {
        const errors = []
        if (!this.$v.frm.referencia.$dirty) return errors
        !this.$v.frm.referencia.required && errors.push('Este campo no puede ser vacío')
        return errors
      },


      razonSocErrors () {
        const errors = []
        if (!this.$v.frm.razonSoc.$dirty) return errors
        !this.$v.frm.razonSoc.maxLength && errors.push('Este campo debe tener como máximo 50 caracteres')
        !this.$v.frm.razonSoc.minLength && errors.push('Este campo debe tener como mínimo 3 caracteres')
        !this.$v.frm.razonSoc.required && errors.push('Este campo no puede ser vacío')
        return errors
      },

      telErrors () {
        const errors = []
        if (!this.$v.frm.tel.$dirty) return errors
        !this.$v.frm.tel.required && errors.push('Este campo no puede ser vacío')
        !this.$v.frm.tel.maxLength && errors.push('Este campo debe tener formato válido')
        !this.$v.frm.tel.minLength && errors.push('Este campo debe tener formato válido')
        return errors
      },

      dirErrors () {
        const errors = []
        if (!this.$v.frm.dir.$dirty) return errors
        !this.$v.frm.dir.required && errors.push('Este campo no puede ser vacío')
        !this.$v.frm.dir.maxLength && errors.push('Este campo debe tener como máximo 50 caracteres')
        !this.$v.frm.dir.minLength && errors.push('Este campo debe tener como mínimo 3 caracteres')
        return errors
      },

      localidadErrors () {

        //console.log(e)

        const errors = []
        if (!this.$v.frm.localidad.$dirty) return errors
        !this.$v.frm.localidad.maxLength && errors.push('Este campo debe tener como máximo 50 caracteres')
        !this.$v.frm.localidad.minLength && errors.push('Este campo debe tener como mínimo 3 caracteres')
        !this.$v.frm.localidad.required && errors.push('Este campo no puede ser vacío')
        return errors
      },

      provinciaErrors () {

        const errors = []
        if (!this.$v.frm.provincia.$dirty) return errors
        !this.$v.frm.provincia.required && errors.push('Este campo no puede ser vacío')
        return errors
      },

      cpErrors () {
        const errors = []
        if (!this.$v.frm.cp.$dirty) return errors
        //!this.$v.frm.cp.numeric && errors.push('Debe ser un CP válido')
        !this.$v.frm.cp.maxLength && errors.push('Este campo debe tener como máximo 10 caracteres')
        !this.$v.frm.cp.minLength && errors.push('Este campo debe tener como mínimo 4 caracteres')
        !this.$v.frm.cp.required && errors.push('Este campo no puede ser vacío')
        return errors
      },

      tEmpresaErrors () {
        const errors = []
        if (!this.$v.frm.tEmpresa.$dirty) return errors
        !this.$v.frm.tEmpresa.required && errors.push('Debe seleccionar una opción')
        return errors
      },

      categoriesErrors () {
        let error=""
        if(this.frm.categories.length==0 && this.errors) error="Debe seleccionar al menos una categoría"
        return error
      },
      keysErrors () {
        let error=""
        if(this.frm.keys.length==0 && this.errors) error="Debe seleccionar al menos una palabra clave"
        return error
      },
*/
      // FIN VALIDACIONES
    },
  }

</script>

<style lang="scss" scoped>

</style>